export default [
  // `Siemens`,
  // `Convotherm`,
  // `Merrychef`,
  // `Dr. Hauschka`,
  // `Dr. Schaer`,
  // `Phocus Brand Contact`,
  // `Scholz + Volkmer`,
  `alvons branding`,
  `Convotherm`,
  `Dr. Schaer`,
  `European Energy Exchange`,
  `Florida TV`,
  `funk`,
  `Heimat`,
  `Hepta`,
  `Hildegard Braukmann`,
  `hlstudios`,
  `Hornbach`,
  `Katrin Bauerfeind`,
  `L’Osteria`,
  `Merrychef`,
  `Pure Water for Generations`,
  `Phocus Brand Contact`,
  `Scholz+Friends`,
  `Scholz+Volkmer`,
  `Siemens Healthineers`,
  `Zeit Online`,
]



// WEBPACK FOOTER //
// ./src/lib/clients.js